<template>
  <div class="sale-subscription-filter">
    <bp-select
      v-model="form.product_id"
      class="mb-5"
      label="Produto"
      id="product-select"
      placeholder="Todos os produtos"
      :options="productOptions"
    />

    <bp-checkboxes-dropdown
      v-model="form.status"
      label="Status"
      :options="statuses"
      placeholder="Selecione o status"
    />

    <div class="d-flex flex-column flex-lg-row justify-content-end gap-5 mt-7">
      <bp-button class="order-lg-1" label="Aplicar" @click="apply" />
      <bp-button
        color="neutral"
        variant="filled-1"
        label="Cancelar"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";
import { mapState } from "vuex";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      statuses: [
        { id: "enable", label: "Ativa" },
        { id: "disable", label: "Inativa" },
        { id: "fail", label: "Falha" },
        { id: "past_due", label: "Atrasada" }
      ],
      ...formFields(["product_id", "status"], {
        ...this.value
      })
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    productOptions() {
      return [
        { id: "", name: "Todos os produtos" },
        ...this.products.filter(p => p.type_product == "signature")
      ];
    }
  },
  methods: {
    apply() {
      this.$emit("input", this.form);
      this.$emit("close");
    }
  }
};
</script>
